import React from 'react'

const Academy = () => {
  return (
    <div>Academy</div>
  )
}

export default Academy